// extracted by mini-css-extract-plugin
export default {"layout":"c115573c67 c6e2b1cdfc _26f8b3900f","h_slide":"_595ee5db21","category":"e878edc272 _2cc763ecd5 _023f93c486"};